export default {
  mainColor: process.env.REACT_APP_OVERRIDE_MAIN_COLOR || '#0facf3',
  black: '#3c4859',
  red: '#cc0000',
  grey: '#cccccc',
  lightGrey: '#eeeeee',
  whiteHighlight: '#f5f5f5',
  green: '#0D6C25'
}


// WEBPACK FOOTER //
// ./src/style/colors.js